  const config = {
    appId: process.env.APP_ID || '0a12d192-0789-4004-ba04-d0e4015bfd70',
   // redirectUri: process.env.REDIRECT_URI || 'https://eportal-uat-thc.rafedsa.com',
    //redirectUri: process.env.REDIRECT_URI || 'https://eportal-uat-thc.rafedsa.com',
    redirectUri: process.env.REDIRECT_URI || 'https://eportal-thc.rafedsa.com',
 //redirectUri:  'http://localhost:3000',
    scopes: [
      process.env.USER_READ_SCOPE || 'user.read',"User.Read", "Calendars.Read",
      // process.env.MAILBOX_SETTINGS_READ_SCOPE || 'mailboxsettings.read',
    ]
  };
  
  
  export default config;
